import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "user-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Email for user of org to switch to (or type \"reset\" to reset your org)", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_input, {
      modelValue: _ctx.orgToEmail,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orgToEmail) = $event)),
      placeholder: "User Name"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, { onClick: _ctx.orgLookup }, {
      default: _withCtx(() => [
        _createTextVNode("Lookup")
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.orgConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(" User: " + _toDisplayString(_ctx.userConfirmEmail), 1),
          _hoisted_4,
          _createTextVNode(" Organization ID: " + _toDisplayString(_ctx.orgConfirm.id) + " ", 1),
          _hoisted_5,
          _createTextVNode(" Organization Name: " + _toDisplayString(_ctx.orgConfirm.name) + " ", 1),
          _hoisted_6,
          _createVNode(_component_el_button, { onClick: _ctx.updateUser }, {
            default: _withCtx(() => [
              _createTextVNode("Switch")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.switchResponse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.switchResponse), 1))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}